// Production-safe logger. Suppresses dev console noise in prod builds so that
// axios error objects (which may contain request URLs / response bodies) are not
// printed in the user's browser devtools when shipped.
const isDev = process.env.NODE_ENV !== 'production';

export const logger = {
  log: (...args) => { if (isDev) console.log(...args); },
  error: (...args) => { if (isDev) console.error(...args); },
  warn: (...args) => { if (isDev) console.warn(...args); },
  info: (...args) => { if (isDev) console.info(...args); },
  debug: (...args) => { if (isDev) console.debug(...args); },
};

export default logger;
